import { useAppSelector } from '../store/store'
import { BusinessRole } from '../types/api/user'

/**
 * Хук для проверки наличия роли у текущего пользователя
 * @param requiredRoles - одна или несколько ролей, которые требуются для доступа
 * @param requireAll - если true, пользователь должен иметь все указанные роли, иначе достаточно одной
 * @returns true, если пользователь имеет требуемые роли
 */
export const useHasRole = (
    requiredRoles: BusinessRole | BusinessRole[],
    requireAll: boolean = false
): boolean => {
    const user = useAppSelector(state => state.auth.user)

    if (!user?.businessRoles || user.businessRoles.length === 0) {
        return false
    }

    const rolesArray = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles]
    const userRoles = user.businessRoles

    if (requireAll) {
        // Пользователь должен иметь все указанные роли
        return rolesArray.every(role => userRoles.includes(role))
    } else {
        // Пользователь должен иметь хотя бы одну из указанных ролей
        return rolesArray.some(role => userRoles.includes(role))
    }
}

/**
 * Хук для проверки наличия любой из указанных ролей (удобный алиас)
 */
export const useHasAnyRole = (requiredRoles: BusinessRole | BusinessRole[]): boolean => {
    return useHasRole(requiredRoles, false)
}

/**
 * Хук для проверки наличия всех указанных ролей
 */
export const useHasAllRoles = (requiredRoles: BusinessRole | BusinessRole[]): boolean => {
    return useHasRole(requiredRoles, true)
}
